import { makeAutoObservable } from "mobx";
import * as serversApi from "../api/serversApi";

class SettingsStore {
  servers = [];
  name = "";
  serverLogin = "";
  serverPassword = "";
  upd = "";
  error = null;
  // Starts true: until the first getServers() resolves, an empty `servers`
  // array is ambiguous between "still loading" and "genuinely none configured".
  serversLoading = true;
  addPending = false;
  deletePending = false;

  constructor() {
    makeAutoObservable(this);
  }

  setServers(servers) {
    this.servers = servers;
  }

  setError(error) {
    this.error = error;
  }

  setName(name) {
    this.name = name;
  }

  setserverLogin(login) {
    this.serverLogin = login;
  }

  setServerPassword(password) {
    this.serverPassword = password;
  }

  setUpd() {
    this.upd = true;
  }

  // Throws on failure (instead of swallowing + returning null) so callers
  // can give the user clear success/failure feedback for this specific
  // action, independent of whatever getServers() does afterwards.
  async postIikoServer(server, pass, login, id, name) {
    this.addPending = true;
    try {
      return await serversApi.addServer({
        server,
        iikoPass: pass,
        id,
        login,
        name,
      });
    } finally {
      this.addPending = false;
    }
  }

  async getServers(id) {
    this.setError(null);
    this.serversLoading = true;
    try {
      const data = await serversApi.getServers(id);
      this.setServers(data);
      return data;
    } catch (e) {
      this.setError(e);
      return null;
    } finally {
      this.serversLoading = false;
    }
  }

  async delteServer(id) {
    this.deletePending = true;
    try {
      return await serversApi.deleteServer(id);
    } finally {
      this.deletePending = false;
    }
  }
}

const settingsStore = new SettingsStore();

export default settingsStore;
